module.exports = __webpack_public_path__ + "img/star.4893a554.svg";